import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormElementsModule } from 'src/app/form-elements';
import { CommonComponentsModule } from 'src/app/common-components';
import { HttpClientModule } from '@angular/common/http';
import { AfterApplyRouteModule } from '../after-apply-route.module';
import {
    PaymentDetailsComponent, ClearToApplyComponent, BeneficiaryDetailsComponent,
    HealthRecordsComponent, DependantHealthRecordsComponent, YourDependantDetailsComponent,
    SubmitApplicationComponent,
    YourLumpSumAllowancesComponent
} from 'src/app/pages/after-apply';
import { AfterApplyComponent } from './after-apply.component';
import { YourPersonalDetailsComponent } from '../components/your-personal-details/your-personal-details.component';
// tslint:disable-next-line:max-line-length
import { YourProductApplicationComponent } from '../components/product-application/your-product-application/your-product-application.component';
// tslint:disable-next-line:max-line-length
import { ApplicationSummaryComponent } from '../components/product-application/application-summary/application-summary.component';
import { YourPensionSavingsComponent } from '../components/your-pension-savings/your-pension-savings.component';
import { UserLoginRequiredComponent } from '../components/user-login-required/user-login-required.component';
import { CustomAddressSearchModule } from 'projects/custom-address-search/src/public-api';
import { CurrencyDirective, CurrencyModule } from 'src/app/shared/directives/currency.directive';
import { ManageAllocationsComponent } from '../components/beneficiary-details/manage-allocations/manage-allocations.component';
@NgModule({
    declarations: [
        AfterApplyComponent,
        ClearToApplyComponent,
        PaymentDetailsComponent,
        HealthRecordsComponent,
        DependantHealthRecordsComponent,
        YourPersonalDetailsComponent,
        YourDependantDetailsComponent,
        BeneficiaryDetailsComponent,
        SubmitApplicationComponent,
        YourProductApplicationComponent,
        ApplicationSummaryComponent,
        YourPensionSavingsComponent,
        UserLoginRequiredComponent,
        YourLumpSumAllowancesComponent,
        ManageAllocationsComponent
    ],
    imports: [
        CommonModule,
        FormElementsModule,
        FormsModule,
        ReactiveFormsModule,
        CommonComponentsModule,
        HttpClientModule,
        AfterApplyRouteModule,
        CustomAddressSearchModule,
        CurrencyModule
    ]
})
export class AfterApplyModule { }
